/* eslint no-console: "off" */
import axios from 'axios';
import auth from '@/common/auth';

export default {
  // eslint-disable-next-line
  responseToChallenge({ commit }, payload) {
    return axios({
      url: 'api/responseToChallenge',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        opponentUsername: payload.opponentUsername,
        challengeAccepted: payload.challengeAccepted,
      },
    });
  },
  // eslint-disable-next-line
  matchingWithUser({ commit }, payload) {
    return axios({
      url: 'api/matchingWithUser',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        opponentUsername: payload.opponentUsername,
        rematch: payload.rematchedGame,
        duelId: payload.duelId,
        stickerChoice: payload.stickerChoice,
        playWithCelebrityBot: payload.playWithCelebrityChoice,
      },
    }).then(response =>
      response, (response) => {
      // eslint-disable-next-line
      console.log(response);
    });
  },
  // eslint-disable-next-line
  sendConversationMessage({ commit }, payload) {
    return axios({
      method: 'get',
      url: 'api/sendMessage',
      headers: {
        Authorization: auth.getJwt(),
      },
      params: payload,
    });
  },
  checkIfGameToResumeExists({ commit, rootState }) {
    // console.clear();
    console.log(`Invoking api/gameToResumeExists?msisdn=${rootState.common.userDetails.msisdn}`);
    return axios({
      method: 'get',
      url: 'api/gameToResumeExists',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log('inside gameToResumeExists');
      const responseData = response.data;
      console.log('responseData:');
      console.log(responseData);
      if (responseData.responseEnum === 'NO_GAME_EXISTS') {
        console.log('NO_GAME_EXISTS');
        commit('setGamePending', false);
        commit('setGameInProgress', false);
        commit('setChallengePending', false);
      } else if (responseData.responseEnum === 'PENDING_GAME_EXISTS') {
        console.log('PENDING_GAME_EXISTS');
        commit('setGamePending', true);
      } else if (responseData.responseEnum === 'PROCESS_ALREADY_HAS_STARTED_PLEASE_WAIT') {
        console.log('PROCESS_ALREADY_HAS_STARTED_PLEASE_WAIT');
        commit('setGamePending', false);
        commit('setGameInProgress', false);
        commit('setChallengePending', true);
      } else if (responseData.responseEnum === 'OPERATION_SUCCESS') {
        console.log('OPERATION_SUCCESS');
        commit('setGamePending', false);
        commit('setChallengePending', false);
        commit('setGameInProgress', false);
        const resumeGameDTO = responseData.data;
        console.log('resumeGameDTO:');
        console.log(resumeGameDTO);
        if (resumeGameDTO !== undefined) {
          const gameDTO = resumeGameDTO.gameDTO;
          console.log('resetting game state...');
          commit('resetGameState');
          commit('setGameID', gameDTO.gameId);
          commit('setGameDTOForResumeGameOnly', gameDTO.gameStateEnum);
          commit('setPlayersDetails', {
            homePlayerMSISDN: gameDTO.homeUserDetails.msisdn,
            homePlayerUsername: gameDTO.homeUserDetails.username,
            homePlayerAvatar: gameDTO.homeUserDetails.avatar,
            homePlayerLevel: gameDTO.homeUserDetails.level,
            awayPlayerMSISDN: gameDTO.awayUserDetails.msisdn,
            awayPlayerUsername: gameDTO.awayUserDetails.username,
            awayPlayerAvatar: gameDTO.awayUserDetails.avatar === '' ? 'static/images/avatar_default.png' : gameDTO.awayUserDetails.avatar,
            awayPlayerLevel: gameDTO.awayUserDetails.level,
          });
          commit('setPlayersCurrentSelectedTheme', {
            homePlayerCurrentSelectedTheme: resumeGameDTO.themeDTO,
            awayPlayerCurrentSelectedTheme: resumeGameDTO.themeDTO,
          });
          commit('setGameInProgress', true);
        }
      }
    }).catch((error) => {
      console.log(`Invoking api/gameToResumeExists failed with the following error: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/actions.js